import styled from '@emotion/styled'

const Italic = styled.em`
  font-style: italic;
`

export { Italic }
